import Vue from 'vue'
import store from "@/core/store";

Vue.mixin({
    methods: {
        waiting(action='fetch') {
            return store.getters.waiting[action]===true
        }
    }
})
